import React, { useState } from "react";
import { Row, Col, Container } from "react-bootstrap";
import { FaChevronLeft } from "react-icons/fa";
import { GoCreditCard } from "react-icons/go";
import { MdOutlineArrowBackIos, MdOutlineQrCodeScanner } from "react-icons/md";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Button from "react-bootstrap/Button";
import { Offcanvas } from "react-bootstrap";
import { CgMenuGridO } from "react-icons/cg";

const VerticalLinearStepper = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [currentStep, setCurrentStep] = useState(1);
  const handleSubmit = (e) => {
    e.preventDefault();
    setCurrentStep((prevStep) => (prevStep < 4 ? prevStep + 1 : prevStep));
  };
  const handleBack = () => {
    setCurrentStep((prevStep) => (prevStep > 1 ? prevStep - 1 : prevStep));
  };


  
  const data = [
    "Secure donation",
    "Enter your details",
    "Enter your address",
    "You donate",
  ];

  return (
    <>
      <Navbar expand="lg" className="main-navbar fixed-top">
        <Container fluid className="p-0">
          <Navbar.Brand href="#home" className="d-flex align-items-center">
            <a
              class="navbar-brand  d-flex align-items-center ms-2 ms-md-4"
              href="#"
            >
              <img src="../images/apslogo.webp" alt="aps" className="img-fluid" />
              <div className="brand-text ms-2 text-left">
                <p className="brand-title">
                  AndhraPradesh State<br></br>
                  <span>Housing</span> Corporation Limited
                </p>
              </div>
              <img src="../images/aplogo.webp" alt="Logo" className="img-fluid" />
            </a>
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            className="border-0"
          />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link className="" href="/">Home</Nav.Link>
              <Nav.Link className="" href="/about">About</Nav.Link>
              <Nav.Link href="/DashBoard">Dashboard</Nav.Link>
              <Nav.Link className="" href="/organogram">Organogram</Nav.Link>
              <Nav.Link className="active" href="/donation">Donation</Nav.Link>
              <Nav.Link className="" href="/contact">Contact Us</Nav.Link>
            </Nav>
            <Button onClick={handleShow} className="menu-btn">
              <CgMenuGridO style={{ fontSize: "35px" }} />
            </Button>
            <Offcanvas
              show={show}
              onHide={handleClose}
              placement="end"
              className="main-off"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title></Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Nav defaultActiveKey="/home" className="side-nav">
                  <Nav.Link href="/home">Gallery</Nav.Link>
                  <Nav.Link href="/organogram"  eventKey="link-1">Organogram</Nav.Link>
                  <Nav.Link eventKey="link-2">Whos is who</Nav.Link>
                  <Nav.Link  href="/contact" eventKey="link-2">Contact US</Nav.Link>
                </Nav>
              </Offcanvas.Body>
            </Offcanvas>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <Container fluid className="newstepper-all">
        <div className="container newstepper container-step">
          <Row>
            <Col xs={12} sm={1} md={1} lg={1} xl={1} xxl={1}></Col>
            {/* Circle Bar with Steps */}
            <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}
              className="circle-bar rounded  position-relative"
            >
     <div className="circle-container-vertical ">
  {data.map((step, index) => (
    <div key={step} className="step-group">
      {/* Circle logic: Active class for current or previous steps */}
      <div
        className={`circle ${currentStep >= index + 1 ? "active" : ""}`}
      >
        {index + 1}
      </div>

      {/* Vertical line logic: Active only if the user has passed this step */}
      {index < data.length - 1 && (
        <div
          className={`circle-container-vertical-line ${
            currentStep > index + 1 ? "active" : ""
          }`}
        ></div> // Vertical line between circles
      )}

      {/* Step label: Apply 'active' class if the circle is active */}
      <span className={`step-label ${currentStep >= index + 1 ? "active" : ""}`}>
        {step}
      </span>
    </div>

  ))}


  {/* <div className="cbottom cornerimage">
  <img src="../images/curve.svg" alt="aps" className="img-fluid" />
  </div> */}
</div>

<img src="../images/curve.svg" alt="aps" className="img-fluid donate-pattern" />


            </Col>
            <Col xs={12} sm={1} md={1} lg={1} xl={1} xxl={1}></Col>

            {/* Form Section */}
            <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className="form-section rounded"
            >
              <div className="form-container">
                {/* Step 1: Secure Donation */}
                {currentStep === 1 && (
                  <form name="step1" onSubmit={handleSubmit}>
                    <h2>Secure donation</h2>
                    <button
                      type="button"
                      onClick={handleBack}
                      className="float-start border-0 bg-transparent d-none"
                      style={{ lineHeight: "15px" }}
                      aria-label="Go back"
                    ></button>
                    <div className="bg-white rounded pb-4">
                      <div className="border-bottom" />
                    </div>

                    <Row className="donate-part">
                      <Col xs={4} sm={4} md={4} lg={4} xl={4} xxl={4} className="text-center mb-2"
                      >
                        <button
                          type="button"
                          className="border rounded p-2 w-100 btn-sm"
                          onClick={() => {}}
                        >
                          ₹1,500
                        </button>
                      </Col>
                      <Col xs={4} sm={4} md={4} lg={4} xl={4} xxl={4} className="text-center mb-2"
                      >
                        <button
                          type="button"
                          className="border rounded p-2 w-100"
                          onClick={() => {
                            // Handle amount selection if needed
                          }}
                        >
                          ₹2,500
                        </button>
                      </Col>
                      <Col xs={4} sm={4} md={4} lg={4} xl={4} xxl={4} className="text-center mb-2"
                      >
                        <button
                          type="button"
                          className="border rounded p-2 w-100"
                          onClick={() => {
                            // Handle amount selection if needed
                          }}
                        >
                          ₹4,000
                        </button>
                      </Col>
                      <Col xs={4} sm={4} md={4} lg={4} xl={4} xxl={4} className="text-center mb-2"
                      >
                        <button
                          type="button"
                          className="border rounded p-2 w-100"
                          onClick={() => {
                            // Handle amount selection if needed
                          }}
                        >
                          ₹8,000
                        </button>
                      </Col>
                      <Col xs={4} sm={4} md={4} lg={4} xl={4} xxl={4} className="text-center mb-2"
                      >
                        <button
                          type="button"
                          className="border rounded p-2 w-100"
                          onClick={() => {
                            // Handle amount selection if needed
                          }}
                        >
                          ₹10K
                        </button>
                      </Col>
                      <Col xs={4} sm={4} md={4} lg={4} xl={4} xxl={4} className="text-center mb-2"
                      >
                        <button
                          type="button"
                          className="border rounded p-2 w-100"
                          onClick={() => {
                          }}
                        >
                          ₹12K
                        </button>
                      </Col>
                      <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mb-2"
                      >
                        <div className="border rounded p-2 d-flex justify-content-between">
                          <div>
                            <span>₹</span>
                            <input type="number" className=" bg-transparent border-0 rupees-number" placeholder="0" />
                          </div>
                          <div className="dd-currency">
                            <select
                              className="form-select py-1 border-0 bg-transparent"
                              aria-label="Default select example"
                              style={{ fontSize: "12px" }}
                            >
                              <option defaultValue>INR</option>
                              <option value="1">Dollar</option>
                              <option value="2">Euro</option>
                              <option value="3">Diner</option>
                            </select>
                          </div>
                        </div>
                      </Col>
                      {/* Donate Monthly Button */}
                      <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}
                        className="text-center mt-5 pt-5"
                      >
                        {/* <button className="btn btn-primary fw-bold w-100 mb-3">
                      Donate Monthly
                    </button> */}
                      </Col>
                    </Row>
                    {/* Next Button */}
                  <div className="mt-5 pt-4">
                  <button type="submit" className="btn donatebtn mt-5 w-100">
                      Donate 
                    </button>
                  </div>
                  </form>
                )}

                {/* Step 2: Enter Your Details */}
                {currentStep === 2 && (
                  <form name="step2" onSubmit={handleSubmit}>
                    <div className="d-flex">
                      <div>
                        <button
                          className="backbtn"
                          type="button"
                          onClick={() => {
                            handleBack();
                          }}
                        >
                          <FaChevronLeft />
                        </button>
                      </div>

                      <div>
                        <h2>Enter Your Details</h2>
                      </div>
                    </div>
                    <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className=""
                    >
                      <div className="bg-white rounded pb-4">
                        {/* Back Button */}
                        <div className="border-bottom">
                          <button
                            type="button"
                            onClick={handleBack}
                            className="float-start border-0 bg-transparent"
                            style={{ lineHeight: "15px" }}
                            aria-label="Go back"
                          >
                            {/* <MdOutlineArrowBackIos /> */}
                          </button>
                        </div>
                        {/* Form Fields */}
                        <div className="m-4 mx-md-0 m-lg-4 rounded border">
                          <div className="form-floating mb-0 border-bottom">
                            <input
                              type="text"
                              className="form-control border-0"
                              id="firstName"
                              placeholder="First Name"
                              required
                            />
                            <label htmlFor="firstName">First Name</label>
                          </div>
                          <div className="form-floating mb-0 border-bottom">
                            <input
                              type="text"
                              className="form-control border-0"
                              id="lastName"
                              placeholder="Last Name"
                              required
                            />
                            <label htmlFor="lastName">Last Name</label>
                          </div>
                          <div className="form-floating mb-0 border-bottom">
                            <input
                              type="email"
                              className="form-control border-0"
                              id="email"
                              placeholder="name@example.com"
                              required
                            />
                            <label htmlFor="email">Email address</label>
                          </div>
                          <div className="form-floating mb-0">
                            <input
                              type="tel"
                              className="form-control border-0"
                              id="phone"
                              placeholder="Phone Number"
                              required
                            />
                            <label htmlFor="phone">Phone</label>
                          </div>
                        </div>
                        {/* Terms of Service */}
                        <div className="m-4 mb-0">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              value=""
                              id="flexCheckDefault"
                              required
                            />
                            <label
                              className="form-check-label"
                              htmlFor="flexCheckDefault"
                            >
                              I agree to the{" "}
                              <a href="#" className="text-black">
                                Terms of Service.
                              </a>
                            </label>
                          </div>

                          {/* Continue Button */}
                          <div className="text-center ">
                            <button
                              type="submit"
                              className="btn donatebtn fw-bold w-100 mt-4"
                            >
                              Continue
                            </button>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </form>
                )}
                {/* Step 3: Enter Your Address */}
                {currentStep === 3 && (
                  <form name="step3" onSubmit={handleSubmit}>
                    <div className="d-flex">
                      <div>
                        <button className="backbtn" type="button" onClick={() => {
                            handleBack();
                          }}
                        >
                          <FaChevronLeft />
                        </button>
                      </div>

                      <div>
                        <h2>Enter Your Address</h2>
                      </div>
                    </div>
                    {/* <button className="backbtn" type="button" onClick={() => { handleBack(); }} > <FaChevronLeft /> </button> */}
                    <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className=""
                    >
                      <div className="bg-white rounded pb-4">
                        <div className="border-bottom">
                          <button
                            type="button"
                            onClick={handleBack}
                            className="float-start border-0 bg-transparent"
                            style={{ lineHeight: "15px" }}
                            aria-label="Go back"
                          >
                          </button>
                        </div>
                        <div className="m-4 mx-md-0 m-lg-4 bg-white rounded border mb-3">
                          <div className="form-floating mb-0 border-bottom">
                            <input
                              type="text"
                              className="form-control border-0"
                              id="streetAddress"
                              placeholder="Street Address"
                              required
                            />
                            <label htmlFor="streetAddress">
                              Street Address
                            </label>
                          </div>
                          <div className="form-floating mb-0 border-bottom">
                            <input
                              type="text"
                              className="form-control border-0"
                              id="apartment"
                              placeholder="Apartment / Suite / Floor"
                              required
                            />
                            <label htmlFor="apartment">
                              Apartment / Suite / Floor
                            </label>
                          </div>
                          <div className="form-floating mb-0">
                            <select
                              className="form-select border-0"
                              id="city"
                              aria-label="Select City"
                              required
                            >
                              <option value="" disabled defaultValue>
                                Select
                              </option>
                              <option value="1">Vijayawada</option>
                              <option value="2">Vizag</option>
                              <option value="3">Hyderabad</option>
                            </select>
                            <label htmlFor="city">City</label>
                          </div>
                        </div>

                        <div className="m-4 mx-md-0 m-lg-4 bg-white rounded border">
                          <div className="d-flex border-bottom">
                            <div className="form-floating mb-0 border-end w-50">
                              <input
                                type="text"
                                className="form-control border-0"
                                id="state"
                                placeholder="State"
                                required
                              />
                              <label htmlFor="state">State</label>
                            </div>
                            <div className="form-floating mb-0 w-50">
                              <input
                                type="text"
                                className="form-control border-0"
                                id="zipCode"
                                placeholder="Zip Code"
                                required
                              />
                              <label htmlFor="zipCode">Zip Code</label>
                            </div>
                          </div>
                          <div className="form-floating">
                            <select
                              className="form-select border-0"
                              id="country"
                              aria-label="Select Country"
                              required
                            >
                              <option value="" disabled defaultValue>
                                Select
                              </option>
                              <option value="1">India</option>
                              <option value="2">USA</option>
                              <option value="3">Japan</option>
                            </select>
                            <label htmlFor="country">Country</label>
                          </div>
                        </div>
                        <div className="m-4 mb-0">
                          <div className="text-center mt-2 pt-2">
                            <button type="submit" className="btn donatebtn fw-bold w-100" >
                              Continue
                            </button>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </form>
                )}
                {currentStep === 4 && (
                  <form name="step4" onSubmit={handleSubmit}>
                    <div className="d-flex">
                      <div>
                        <button className="backbtn" type="button" onClick={() => { handleBack(); }}
                        ><FaChevronLeft /></button>
                      </div>
                      <div>
                        <h2>Your Donation</h2>
                      </div>
                    </div>
                    <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className=""
                    >
                      <div className="bg-white rounded pb-4">
                        <div className="border-bottom">
                          <button
                            type="button"
                            onClick={handleBack}
                            className="float-start border-0 bg-transparent"
                            style={{ lineHeight: "15px" }}
                            aria-label="Go back"
                          >
                          </button>
                        </div>
                        <div className="m-4 mb-3">
                          <div className="my-5 text-center fs-3">
                            ₹8,560 <small className="fs-6">INR</small>
                          </div>
                        </div>
                        <div className="m-4 mb-0">
                          <div className="text-center mt-5 pt-5">
                            <button
                              type="button"
                              className="btn creditcard fw-bold w-100 mb-2"
                              onClick={() => {
                              }}
                            >
                              <GoCreditCard /> Card
                            </button>
                            <button type="button" className="btn upipayment fw-bold w-100" onClick={() => {
                              }}
                            >
                              <MdOutlineQrCodeScanner /> UPI
                            </button>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <button type="submit" className="btn donatebtn mt-3">
                      Submit
                    </button>
                  </form>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
};
export default VerticalLinearStepper;
